module.exports = __webpack_public_path__ + "img/Group-900.09f26362.png";